import { Controller } from "@hotwired/stimulus"

// Scrolls itself into view on connect. Attached to the form's error banner:
// Turbo keeps the scroll position when a submission is rejected (422), so a
// user editing trips further down the page would otherwise get no visible
// feedback at all and assume the save silently did nothing (SBAU-590).
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ behavior: "smooth", block: "center" })
  }
}
